
angular.module('bmsApp.crm.prospect').factory('ProspectStageSvc', function (CRUDSvc, PROSPECT_STAGE_API) {

	return {
		options: function () {
			return CRUDSvc.get(PROSPECT_STAGE_API.OPTIONS);
		}
	};

}).constant('PROSPECT_STAGE_API', {
	OPTIONS: 'api/prospectStage/options'
});
